import sessionStorage from 'common/helpers/sessionStorage';
import { isCustomColourConversionActive } from 'common/helpers/projectInitUtil';
import { CUSTOM_COLOR_CONVERSION_KEY } from 'common/constants/General';
import * as colourMaps from './PwcToJunctionStyles';

export const intersect = (a1, a2) =>
  a1 && a2 ? a1.filter((x) => a2.includes(x)) : [];

export const mapToJunctionStyles = (html) => {
  let mapped = html;
  const contentColourConversion = sessionStorage.get(
    CUSTOM_COLOR_CONVERSION_KEY
  );
  const isCustomColourConversion = isCustomColourConversionActive(
    contentColourConversion
  );

  // Do the colours
  // When we apply the new Aspose workflow to PPT, this code will need a switch on content type (SVG, table, or PPT)
  const colourMap =
    html.indexOf('svg') > -1
      ? colourMaps.pwcToJunctionChartColours
      : colourMaps.pwcToJunctionTableColours;
  if (!isCustomColourConversion) {
    Object.keys(colourMap).forEach((sourceKey) => {
      const regex = new RegExp(`${sourceKey}`, 'mig');
      mapped = mapped.replace(regex, colourMap[sourceKey]);
    });
  }
  // Some hacks to get round Aspose's embedded MS derived styles
  const borderRightStringPattern = 'border-right:1px solid #000000';
  const borderRightRegex = new RegExp(`${borderRightStringPattern}`, 'mig');
  const borderRightReplacementString =
    'border-right:1px solid var(--table-border-color)';

  mapped = mapped.replace(borderRightRegex, borderRightReplacementString);

  const whiteBgStringPattern = 'background:#FFFFFF';
  const whiteBgRegex = new RegExp(`${whiteBgStringPattern}`, 'mig');
  mapped = mapped.replace(whiteBgRegex, '');
  mapped = mapped.replace(
    '<svg',
    '<svg style="max-width:100%;max-height:100%;" '
  );
  return mapped;
};
